import { FormChecker } from "../class/_formChecker.js";
import { FormItemChecker } from "../class/_formItemChecker.js";
import { InputValidator } from "../class/_inputValidator.js";
import { SelectionValidator } from "../class/_selectionValidator.js";

/**
 * バリデーションを実行します
 * @returns { void }
 */
 let validatorInstances       = [];
 let formCheckerInstances     = [];
 let formItemCheckerInstances = [];

export const validation          = () => {
  const forms = document.querySelectorAll( 'form.p-form' ) || null;
 
  const validateEvents           = 'focusout,keyup,change'.split( ',' );
  const errorEvents              = 'focusout,change'.split( ',' );

  if ( forms ) {
    for ( let i = 0; i < forms.length; i++ ) {
      validatorInstances[ i ]       = [];
      formItemCheckerInstances[ i ] = [];

      const targets   = forms[i].querySelectorAll( '.c-input, .c-textarea, .c-select, .js-selection' );
      /**
       * ページ読み込み時、まずは Validator クラスのインスタンスを生成
       * そしてバリデーションを実行
       */
      targets.forEach( ( target, index ) => {
        if ( target.classList.contains( 'js-selection' ) ) {
          validatorInstances[ i ][ index ] = new SelectionValidator( target );
          validatorInstances[ i ][ index ].validateRun();
        } else {
          validatorInstances[ i ][ index ] = new InputValidator( target );
          validatorInstances[ i ][ index ].validateRun();

            // 入力内容を自動反映させる
            if ( target.getAttribute( 'data-confirm' ) ) {
              const inputDisplay     = document.getElementById( target.getAttribute( 'data-confirm' ) );
              const value            = validatorInstances[ i ][ index ].value;
              inputDisplay.innerHTML = value;
            }
        }

        // 入力、変更時に再度バリデーションを行う
        validateEvents.forEach( validateEvent => {
          target.addEventListener( validateEvent, () => {
            validatorInstances[ i ][ index ].setValue( target.value );
            validatorInstances[ i ][ index ].validateRun();

            // 入力内容を自動反映させる
            if ( target.getAttribute( 'data-confirm' ) ) {
              const inputDisplay     = document.getElementById( target.getAttribute( 'data-confirm' ) );
              const value            = validatorInstances[ i ][ index ].value;
              inputDisplay.innerHTML = value;
            }
          } );
        } );
      } );

      const formItems = forms[i].querySelectorAll( '.p-form-item, .js-form-item' );
      formItems.forEach( ( formItem, index2 ) => {
        const instances = [];
        validatorInstances[ i ].forEach( validatorInstance => {
          if ( formItem === validatorInstance.getParentItem() ) {
            instances.push( validatorInstance );
          }
        } );

        /**
         * .p-form-item 毎に FormItemChecker クラスのインスタンスを生成
         * .p-form-item 内のエラーをチェックして、チェックアイコンを変化
         */
        formItemCheckerInstances[ i ][ index2 ] = new FormItemChecker( instances, formItem );
        formItemCheckerInstances[ i ][ index2 ].reflectToggleCheckIcon();

        /**
         * フォーカスアウト時 エラーメッセージを出力する
         */
        errorEvents.forEach( errorEvent => {
          formItem.addEventListener( errorEvent, () => {
            formItemCheckerInstances[ i ][ index2 ].reflectErrorMessage();
            formItemCheckerInstances[ i ][ index2 ].reflectToggleCheckIcon();
          } );
        } );
      } );

      /**
       * .p-form 毎に FormChecker クラスのインタンスを生成
       * .p-form 全体のエラーをチェック
       */
      formCheckerInstances[ i ] = new FormChecker( validatorInstances[ i ], formItemCheckerInstances[ i ], forms[i] );
      formCheckerInstances[ i ].reflectErrorNum();
      formCheckerInstances[ i ].checkAll();

      /**
       * focusout、change で .p-form 全体のエラーチェック
       */
      errorEvents.forEach( errorEvent => {
        forms[ i ].addEventListener( errorEvent, ( event ) => {

          formItemCheckerInstances[ i ].forEach( item => {
            item.validateRunThisFormItem();
            item.reflectToggleCheckIcon();
            if ( item.target.classList.contains( 'js-hide-form-reserve' ) ) {
              item.reflectErrorMessage();
            }
          } );

          formCheckerInstances[ i ].reflectErrorNum();
          formCheckerInstances[ i ].checkAll();
        } );
      } );
    }
  }
}
/**
 * プルダウン項目にバリデーション追加します
 * (Ajaxで、プルダウン項目を再生成した場合に、バリデーションメソッドを追加する関数)
 * 
 * @param  target　再生成したプルダウンのDOM
 * 
 */
export const validationAdd = ( target ) => {

  // const forms = document.querySelectorAll('form.p-form') || null;
  let validatorInstance;
  const validateEvents = 'focusout,keyup,change'.split(',');
 
  if ( target === undefined || target === null ) {
    return;
  }
  /**
     * ページ読み込み時、まずは Validator クラスのインスタンスを生成
     * そしてバリデーションを実行
  */
  for (let i = 0; i < validatorInstances.length; i++) {
    if (target.classList.contains('js-selection')) {
      validatorInstance = new SelectionValidator(target);
    }
    else if (target.classList.contains('c-select')) {
      validatorInstance = new InputValidator(target);
    }
    else {
      return;
    }

    let existFlg = false;
    for (let j = 0; j < validatorInstances[i].length; j++) {
      if (validatorInstances[i][j].target.getAttribute('name') === target.getAttribute('name')) {
        
        // 一致した場合、フラグ更新とバリデーション実行
        existFlg = true;
        validatorInstance.validateRun();

        // 入力内容を自動反映させる
        if (target.getAttribute('data-confirm')) {
          const inputDisplay = document.getElementById(target.getAttribute('data-confirm'));
          const value = validatorInstance.value;
          inputDisplay.innerHTML = value;
        }

        // インスタンスを更新
        validatorInstances[i][j] = validatorInstance;
        break;
      }
    }

    // 引数で渡されたDOMは元々存在しなかった場合（不正なDOM）
    if ( !existFlg ) {
      return;
    }

    // 入力、変更時に再度バリデーションを行う
    validateEvents.forEach(validateEvent => {
      target.addEventListener(validateEvent, () => {
        validatorInstance.setValue(target.value);
        validatorInstance.validateRun();

        // 入力内容を自動反映させる
        if (target.getAttribute('data-confirm')) {
          const inputDisplay = document.getElementById(target.getAttribute('data-confirm'));
          const value = validatorInstance.value;
          inputDisplay.innerHTML = value;
        }
      });
    });

    for (let j = 0; j < formItemCheckerInstances[i].length; j++) {
      const instances = [];
      validatorInstances[i].forEach(validatorInstance => {
        if (formItemCheckerInstances[i][j].target === validatorInstance.getParentItem()) {
          instances.push(validatorInstance);
        }
      });

      formItemCheckerInstances[i][j].validators = instances;
      formItemCheckerInstances[i][j].reflectToggleCheckIcon();
    }

    formCheckerInstances[ i ].reflectErrorNum();
    formCheckerInstances[ i ].checkAll();
  }  
}